import styled, { keyframes } from 'styled-components';
import CircularProgressProps from './type';

const loadingAnimation = keyframes`
    from {
        transform: rotate(-0deg);
    }
    100% {
        transform: rotate(-360deg);
    }
`;

export const WrapperStyled = styled.div<CircularProgressProps>`
  width: ${({ size }) => size || '100%'};
  height: ${({ size }) => size || '100%'};
  position: relative;
  justify-content: center;
  align-items: center;
`;

export const LabelStyled = styled.div`
  position: absolute;
  z-index: 1;
  margin: auto;
  width: min-content;
  height: 44px;
  left: 0;
  right: 0;
  top: 0;
  border-radius: 50px;
  background: #f0f0f3;
  transform: translateY(-20%);
  padding-inline: 9px;
  p {
    height: 100%;
    text-align: center;
    vertical-align: middle;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: inherit;
    margin: 0;
    color: ${({ theme: { colors } }) => colors.gray700};
    ${({ theme: { typography } }) => typography.header2}
  }
`;

export const CircleLoadingStyled = styled.div<CircularProgressProps>`
  position: absolute;
  margin: auto;
  width: ${({ circleSize, size }) => circleSize || `calc(${size}/10)`};
  height: ${({ circleSize, size }) => circleSize || `calc(${size}/10)`};

  border-radius: 50%;
  left: 0;
  right: 0;
  top: 0;
  ${({ theme: { colors }, value, size, loadingMode }) => {
    if (loadingMode) {
      return `
      transform-origin: center calc(${size}/2);
      background-color: ${colors.green500};
      `;
    }
    return `
    background-color: ${colors.blue500};
    transform-origin: center calc(${size}/2);
    transform: rotate(-${(value * 360) / 100}deg);
  `;
  }}
  animation: ${({ loadingMode }) => (loadingMode ? loadingAnimation : 'none')} 1.5s linear infinite;
`;

export const ColoredExtraBackgroundStyled = styled.div<CircularProgressProps>`
  height: 100%;
  width: 100%;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  visibility: ${({ loadingMode }) => (!loadingMode ? 'visible' : 'hidden')};
  border-radius: 50%;
  background: ${({ theme: { colors } }) => {
    return `conic-gradient( from 0deg at 50% 50%, ${colors.blue500}, transparent 25% 25%);`;
  }};
`;

export const LoadingGraphStyled = styled.div<CircularProgressProps>`
  height: 100%;
  width: 100%;
  position: absolute;
  ${({ loadingMode, value, theme: { colors } }) => {
    if (loadingMode) return `background: conic-gradient(${colors.green500}, transparent 0.9turn);`;
    return `
      transform: scaleX(-1);
      background: conic-gradient(from 0deg at 50% 50%, ${colors.blue500} ${value}%, transparent ${value}%);
      animation: None !important;
      `;
  }}
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${loadingAnimation} 1.5s linear infinite;
`;

export const CenterContentStyled = styled.div`
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 80%;
  height: 80%;
  border-radius: 50%;
  background-color: #f0f0f3;
`;

export const ContentImage = styled.div<CircularProgressProps>`
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-image: ${({ photoSrc }) => `url(${photoSrc})`};
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

export const BorderContentBackground = styled.div`
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 80%;
  height: 80%;
  padding: 2px;
  border-radius: 50%;
  background-color: linear-gradient(#d6e3f3, #fff);
`;

export const ContentBackground = styled.div<CircularProgressProps>`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  box-shadow: 4px 4px 14px 0px #c1d5ee inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
  background-color: ${({ loadingMode }) =>
    loadingMode ? `rgb(149, 210, 28, 0.2);` : `rgba(102, 174, 255, 0.2);`};
`;
